import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const LaunchFocus = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M15 4h4a1 1 0 0 1 1 1v4M4 15v4a1 1 0 0 0 1 1h4M19.5 4.5 15 9m-6 6-4.5 4.5M20 15v4a1 1 0 0 1-1 1h-4M9 4H5a1 1 0 0 0-1 1v4m15.5 10.5L15 15M9 9 4.5 4.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.25 5c0-.966.784-1.75 1.75-1.75h4a.75.75 0 0 1 0 1.5H5.81l3.72 3.72a.75.75 0 0 1-1.06 1.06L4.75 5.81V9a.75.75 0 0 1-1.5 0zm11-1a.75.75 0 0 1 .75-.75h4c.966 0 1.75.784 1.75 1.75v4a.75.75 0 0 1-1.5 0V5.81l-3.72 3.72a.75.75 0 1 1-1.06-1.06l3.72-3.72H15a.75.75 0 0 1-.75-.75m-11 11a.75.75 0 0 1 1.5 0v3.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-3.72 3.72H9a.75.75 0 0 1 0 1.5H5A1.75 1.75 0 0 1 3.25 19zM20 14.25a.75.75 0 0 1 .75.75v4A1.75 1.75 0 0 1 19 20.75h-4a.75.75 0 0 1 0-1.5h3.19l-3.72-3.72a.75.75 0 1 1 1.06-1.06l3.72 3.72V15a.75.75 0 0 1 .75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
